import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AdminClockedInTherapistsModel } from '../../../../../models/api/AdminClockedInTherapistsModel';
import { DashboardService } from '../../../../../services/api/DashboardService';
import { TherapistService } from '../../../../../services/api/TherapistService';
import { TherapistAddEditComponent } from '../../../../therapists/therapist-add-edit/therapist-add-edit.component';
import { EventService } from '../../../../../services/api/EventService';
import { EventModel } from '../../../../../models/api/EventModel';
import { forkJoin, interval, startWith, Subject, takeUntil } from 'rxjs';
import { HelpersModule } from '../../../../../helpers/helpers';

@Component({
  selector: 'app-event-therapists-waiting',
  standalone: true,
  imports: [MatTableModule, RouterModule, MatTooltipModule, DatePipe, MatIconModule, MatSortModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule, MatSidenavModule, TherapistAddEditComponent, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './event-therapists-waiting.component.html',
  styleUrl: './event-therapists-waiting.component.scss'
})
export class EventTherapistsWaitingComponent implements OnInit, OnDestroy {

  displayedColumns: string[] = ['image', 'firstName', 'lastName', 'waiting', 'status', 'breakTime', 'totalTime', 'clockedInTime'];
  dataSource = new MatTableDataSource<AdminClockedInTherapistsModel>();
  public eventID: number = 0;

  therapists: AdminClockedInTherapistsModel[] = [];
  eventDetail: EventModel = new EventModel;

  public isLoaded: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private therapistService: TherapistService,
    private eventService: EventService,
        private snackbar: MatSnackBar,
        private route: ActivatedRoute,
  ) {
        this.eventID = Number(this.route.snapshot.paramMap.get('id'));

  }

    private destroy$ = new Subject<void>();
  
  ngOnInit(): void {
    interval(10000)
      .pipe(
        startWith(0),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        if (this.eventID > 0) {
        this.getTherapists();
      }
      });
  }
  
    ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getTherapists() {


    forkJoin({
      eventDetail: this.eventService.getEvent(this.eventID),
      therapists: this.dashboardService.getTherapistsWaitingByEvent(this.eventID)
    }).subscribe({
      next: ({ eventDetail, therapists }) => {
        this.eventDetail = eventDetail;
        this.therapists = therapists;

        this.therapists.forEach(x => {
          if (x.clockedInTime) {
            x.clockedInTime = toUtcDate(x.clockedInTime);
          }
          if (x.currentMassageDetails?.treatmentStart) {
            x.currentMassageDetails.treatmentStart = toUtcDate(x.currentMassageDetails.treatmentStart);
          }
          if (x.currentMassageDetails?.treatmentEnd) {
            x.currentMassageDetails.treatmentEnd = toUtcDate(x.currentMassageDetails.treatmentEnd);
          }
        });

        this.dataSource.data = this.therapists;


        this.isLoaded = true;
      },
      error: (err) => {
        this.isLoaded = false;
      }
    });
  }
  
  getMinsActive(clockInTime: any){
    const clockInTimeNow = new Date(clockInTime);
    const timeNow = new Date();

    const timeInMins = Math.round((timeNow.getTime() - clockInTimeNow.getTime())/ (1000 * 60));

    return timeInMins;
  }

  getThumbURL(url: string | undefined | null): string | undefined | null {
    if (url == undefined || url == null)
      return url;

    return HelpersModule.cloudinaryURLForceWidth(url, 80);
  }

}

function toUtcDate(date: string | Date): Date {
  if (date instanceof Date) {
    const isoString = date.toISOString();
    return new Date(isoString);
  } else {
    return new Date(date.endsWith('Z') ? date : date + 'Z');
  }
}
